import React from 'react'

import { Modal, Form, Row, Col, Divider, Button, Table } from '_zari/core'

const ResumenModal = ({ show, handleClose, modalData }) => {
  return (
    <Modal size='lg' show={show}>
      <Modal.Body>
        <Row>
          <Col md={8} />
          <Col md={4} className='text-center'>
            <p>GUIA DE EMISION</p>
            <p>ELECTRONICA REMITENTE</p>
            <p>{`${modalData.serieDocumento} - ${modalData.numeroDocumento}`}</p>
          </Col>
        </Row>
        <Divider title='DATOS DEL TRASLADO' noMargin />
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='Fecha de Emision :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.fechaEmision || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Fecha de Inicio de Traslado :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.fechaInicio || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Motivo de Traslado :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.codigoMotivo || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Modalidad de Traslado :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.modalidad || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Peso bruto total :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.pesoBrutoTotal || '--'} noPadding />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Divider title='DATOS DEL DESTINATARIO' />
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='Razon Social :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.nombreSocio || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Documento de Identidad :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.documentoSocio || '--'} noPadding />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        {/* <Divider title='DATOS DEL PUNTO PARTIDA Y PUNTO DE LLEGADA' />
        <Row>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='Direccion punto de partida :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.puntoPartida || '--'} noPadding />
              </Col>
            </Form.Group>
            <Form.Group>
              <Form.Label text='Direccion punto de llegada :' noPadding md={3} alignRightAt='md' />
              <Col md={9}>
                <Form.OnlyText text={modalData.puntoLlegada || '--'} noPadding />
              </Col>
            </Form.Group>
          </Col>
        </Row> */}
        <Divider title='DATOS DEL TRANSPORTE' />
        <Row>
          <Col md={12}>
            <p>Datos de los bienes</p>
            <Table
              maxRowsShown={5}
              filas={modalData.detalles || []}
              headRows={[
                { label: 'Nro.' },
                { label: 'Cod. Bien' },
                { label: 'Descripcion' },
                { label: 'U. Medida' },
                { label: 'Cantidad' }
              ]}
              rowTemplate={(row, k) => (
                <Table.Row key={k}>
                  <Table.Cell>{k + 1}</Table.Cell>
                  <Table.Cell>{row.codigoProducto || '--'}</Table.Cell>
                  <Table.Cell>{row.nombreProducto || '--'}</Table.Cell>
                  <Table.Cell>{row.nombreUnidadDeMedida || row.unidadMedida || '--'}</Table.Cell>
                  <Table.Cell>{row.cantidad || '--'}</Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={handleClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(ResumenModal)
